<template>
  <div class="d-flex purchase justify-content-center general">
    <Purchase class="isDesktop" />
    <!-- <Mobile class="isMobile" /> -->
  </div>
</template>

<script>
import Purchase from "../../components/Purchase/Index-Purchase.vue";
// import Mobile from "../../components/Purchase/mobile.vue";
export default {
  components: {
    Purchase,
    // Mobile,
  },
};
</script>
<style scoped>
.isMobile {
  display: none !important;
}
@media screen and (max-width: 700px) {
  .isDesktop {
    display: none !important;
  }
  .isMobile {
    display: flex !important;
  }
}
</style>